import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { getUser } from '../../actions/session';
import { GET_ALL_ACCOUNTS, INVOICE_DOWNLOAD_API, INVOICE_SEND_API, CREATE_RESTRICTION, INVOICE_LIST_API } from '../../config/rest_endpoints';
import CustomLoader from '../common/loader';
import CustomModal from '../common/modal';
import DatePicker from "react-datepicker";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import setSeconds from "date-fns/setSeconds";
import { RC_LOAD_LOGIN } from '../routers/RouteConstants';
import { Notifications } from '../common/notification';
import { withRouter } from 'react-router';
import Select from 'react-select';
import Pagination from "react-js-pagination"
import { fmtDollar4, fmtMins } from '../common/formatters';

// datetime picker imports
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from "moment";

const getLastBillingDate = () => {
    const today = moment().utc().startOf('day');
    const candidates = [];

    // Last Sunday (weekly invoice createDate = end of billing period = Sunday)
    if (today.day() === 0) {
        candidates.push(today.clone());
    } else {
        candidates.push(today.clone().subtract(today.day(), 'days'));
    }

    // 15th of current month if on or before today
    const fifteenth = today.clone().startOf('month').date(15);
    if (fifteenth.isSameOrBefore(today)) {
        candidates.push(fifteenth);
    }
    // 15th of previous month
    candidates.push(today.clone().subtract(1, 'month').startOf('month').date(15));

    // Last day of previous month
    candidates.push(today.clone().subtract(1, 'month').endOf('month').startOf('day'));

    // Last day of current month if today is that day
    const lastDayThisMonth = today.clone().endOf('month').startOf('day');
    if (lastDayThisMonth.isSameOrBefore(today)) {
        candidates.push(lastDayThisMonth);
    }

    // Return the most recent one
    let mostRecent = candidates[0];
    candidates.forEach((d) => {
        if (d.isSameOrBefore(today) && d.isAfter(mostRecent)) {
            mostRecent = d;
        }
    });
    return mostRecent;
};

const InvoiceTable = (props) => {

    const strDate = getLastBillingDate().toDate();
    const enDate = moment().utc().startOf('day').toDate();

    const [tableData, setTableData] = useState([])
    const [userInfo] = useState(getUser())
    const [isGetting, setIsGetting] = useState(false)
    const [isExpire, setisExpire] = useState(false)
    const [startDate, setStartDate] = useState(strDate)
    const [endDate, setEndDate] = useState(enDate)
    const [accountOption, setAccountOption] = useState([])
    const [accountSelect, setAccountSelect] = useState('')
    const [isChecked, setisChecked] = useState(true)
    const [activePages, setActivePages] = useState(1)
    const [totalCount,setTotalCount] = useState(null)
    const [itemCounts, setItemCounts] = useState({ label: '10', value: 10 })
    const [countList] = useState([
        { label: '10', value: 10 },
        { label: '15', value: 15 },
        { label: '25', value: 25 },
        { label: '50', value: 50 },
        { label: 'All', value: 400 },
    ])
    const [isBtnSpin, setisBtnSpin] = useState(false);
    const [isDownLoadSpin, setisDownLoadSpin] = useState(null);
    const [sendingInvoiceId, setSendingInvoiceId] = useState(null);
    const [previewingInvoiceId, setPreviewingInvoiceId] = useState(null);
    const [confirmInvoice, setConfirmInvoice] = useState(null);
    const [emailPreview, setEmailPreview] = useState(null);

    useEffect(() => {
        getInvoiceList()
        getAccountList()
        
    }, [activePages])

    useEffect(() => {
        getInvoiceList()
        setisBtnSpin(false)
    }, [itemCounts])

    const handleDate = (date, value) => {
        if (value == "start") {
            setStartDate(date)
        } else {
            setEndDate(date)
        }
    }

    const handleSelectPagination = (itemCounts) => {
        setItemCounts(itemCounts)
    }

    const handleChecked = () => {
        setisChecked(!isChecked)
    }

  
    const handleAccountSelect = (accountSelect) => {
        setAccountSelect(accountSelect)
    }

    const getAccountList = () => {
        let User = userInfo
        var headers = { "Authorization": "Bearer " + User.token };
        Axios.get(GET_ALL_ACCOUNTS, { headers }).then(res => {
            if (res) {
                let resp = res.data.data
                let getOption = resp.map((row) => {
                    row['label'] = row['accountName']
                    row['value'] = row['id']
                    return row
                })
                setAccountOption(getOption)
            }
            else {
                Notifications.notify("Fetch failed", "error", "errors")
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
        })
    }

    const handlePageNumber = (pageNumber) => {
        setActivePages(pageNumber)
    }

    const getInvoiceList = () => {
        let User = userInfo
        var headers = { "Authorization": "Bearer " + User.token };
        var payload = {
            // "startDate": startDate.toLocaleString(),
            // "endDate": endDate.toLocaleString()
            "startDate": moment(startDate).format('MM/DD/YYYY, h:mm:ss A'),
            "endDate": moment(endDate).format('MM/DD/YYYY, h:mm:ss A')
        }
        let accountId = accountSelect === null ? undefined :accountSelect.value
        setIsGetting(true)
        setisBtnSpin(true)
        Axios.post(`${INVOICE_LIST_API}?accountID=${accountId}&excludeZero=${isChecked ? 'yes' : 'no'}&page=${activePages}&search=&limit=${itemCounts.value}`, payload, { headers }).then(res => {
            if (res) {
                let resp = res.data.data
                setTableData(resp)
                setIsGetting(false)
                setisBtnSpin(false)
                setTotalCount(res.data.pageinfo.totalCount)
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                setisExpire(true)
                localStorage.removeItem('user');
                props.history.push(RC_LOAD_LOGIN);
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            setIsGetting(false)
            setisBtnSpin(false)

        })
    }

    const onDonwload = (data) => {
        if (isDownLoadSpin) return
        setisDownLoadSpin(data.id)
        let User = userInfo
        var headers = { "Authorization": "Bearer " + User.token }
        Axios.get(`${INVOICE_DOWNLOAD_API}/${data.id}/download`, { headers, responseType: 'blob' })
            .then(res => {
                const disposition = res.headers['content-disposition'] || ''
                const match = disposition.match(/filename="?([^";]+)"?/i)
                const fallbackName = `CCS Invoice - ${data.accountName}.pdf`
                const filename = match ? match[1] : fallbackName
                const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', filename)
                document.body.appendChild(link)
                link.click()
                link.remove()
                window.URL.revokeObjectURL(url)
                setisDownLoadSpin(null)
            })
            .catch(() => {
                setisDownLoadSpin(null)
                Notifications.notify("Failed to download invoice", "Error", "error")
            })
    }

    const onSendInvoice = (data) => {
        if (previewingInvoiceId || sendingInvoiceId) return
        setPreviewingInvoiceId(data.id)
        setEmailPreview(null)
        let User = userInfo
        var headers = { "Authorization": "Bearer " + User.token }
        Axios.get(`${INVOICE_SEND_API}/${data.id}/preview`, { headers })
            .then(res => {
                setEmailPreview(res.data.data)
                setConfirmInvoice(data)
                setPreviewingInvoiceId(null)
            })
            .catch(err => {
                setPreviewingInvoiceId(null)
                const msg = err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : "Failed to load invoice email preview"
                Notifications.notify(msg, "Error", "error")
            })
    }

    const onConfirmSend = () => {
        if (!confirmInvoice || sendingInvoiceId) return
        const invoiceId = confirmInvoice.id
        setSendingInvoiceId(invoiceId)
        setConfirmInvoice(null)
        setEmailPreview(null)
        let User = userInfo
        var headers = { "Authorization": "Bearer " + User.token }
        Axios.post(`${INVOICE_SEND_API}/${invoiceId}/send`, {}, { headers })
            .then(res => {
                setSendingInvoiceId(null)
                Notifications.notify(res.data.message || "Invoice sent successfully", "Success", "success")
            })
            .catch(err => {
                setSendingInvoiceId(null)
                const msg = err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : "Failed to send invoice"
                Notifications.notify(msg, "Error", "error")
            })
    }

    const renderTableData = () => {
        if (tableData === null || tableData.length === 0) {
            return (
                <div className=" ml-3">
                    <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0</div>
                    <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                </div>
            )
        }
        else {
            return tableData.map((row, idx) => {
                return (<tr key={idx}>
                    <td>{row['accountName']}</td>
                    <td>{row['createDate']}</td>
                    <td>{row['frequency']}</td>
                    <td>{row['dateRange']}</td>
                    <td>{row['invoiceNumber']}</td>
                    <td style={{textAlign:'right'}}>{fmtMins(row['outboundMinutes'])}</td>
                    <td style={{textAlign:'right'}}>{fmtDollar4(row['outboundCost'])}</td>
                    <td style={{textAlign:'right'}}>{fmtDollar4(row['totalAmount'])}</td>
                    <td><button type="button" className="main-button btn btn-success btn-icon border-2 ml-2" onClick={onDonwload.bind(this, row)} disabled={isDownLoadSpin === row.id}>{isDownLoadSpin === row.id ? <i className="icon-spinner4 spinner"></i> : <i className="icon-file-pdf"></i>}</button></td>
                    <td>
                        <button
                            type="button"
                            className="main-button btn btn-primary btn-icon border-2 ml-2"
                            onClick={onSendInvoice.bind(this, row)}
                            disabled={sendingInvoiceId === row.id || previewingInvoiceId === row.id}
                            title="Preview invoice email"
                        >
                            {sendingInvoiceId === row.id || previewingInvoiceId === row.id
                                ? <i className="icon-spinner4 spinner"></i>
                                : <i className="icon-envelop"></i>
                            }
                        </button>
                    </td>
                </tr>)
            })
        }
    }


    const closeEmailPreview = () => {
        setConfirmInvoice(null)
        setEmailPreview(null)
    }

    const confirmModalBody = confirmInvoice && emailPreview ? (
        <div>
            {emailPreview.testMode && (
                <div className="alert alert-warning" style={{fontWeight:'600'}}>
                    Test mode is active. This email can only be sent to {emailPreview.to}.
                </div>
            )}
            <p style={{margin:'0 0 16px',color:'#475569',fontSize:'13px'}}>
                Review the complete email below. Nothing is sent until you click Send Invoice.
            </p>
            <table style={{width:'100%',borderCollapse:'collapse',fontSize:'13px'}}>
                <tbody>
                    {[
                        ['From', emailPreview.from],
                        ['To', emailPreview.to],
                        ['Subject', emailPreview.subject],
                        ['Attachment', emailPreview.attachment],
                    ].map(([label, value], i) => (
                        <tr key={i} style={{background: i % 2 === 0 ? '#F8FAFC' : '#fff'}}>
                            <td style={{padding:'10px 12px',fontWeight:'600',color:'#64748B',width:'40%',borderBottom:'1px solid #F1F5F9'}}>{label}</td>
                            <td style={{padding:'10px 12px',color:'#0F172A',fontWeight: label === 'Total Amount' ? '700' : '500',borderBottom:'1px solid #F1F5F9',
                                color: label === 'Sending To' ? '#1D4ED8' : label === 'Total Amount' ? '#047857' : '#0F172A'}}>{value}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div style={{marginTop:'16px',padding:'16px',border:'1px solid #E2E8F0',borderRadius:'8px',background:'#fff'}} dangerouslySetInnerHTML={{__html: emailPreview.body}} />
        </div>
    ) : null

    return (
        <div>
            {confirmInvoice && emailPreview && (
                <CustomModal
                    visibility={!!confirmInvoice}
                    modalSize="large"
                    details={{ info: 'Preview Invoice Email', msg: confirmModalBody }}
                    crossBtn={{ action: closeEmailPreview }}
                    cancelBtn={{ label: 'Cancel', action: closeEmailPreview }}
                    confirmBtn={{ label: 'Send Invoice', action: onConfirmSend }}
                    showBtns={true}
                    enableBackDrop={true}
                />
            )}
            <div style={{border:'1px solid #E2E8F0',borderRadius:'16px',background:'#FFFFFF',boxShadow:'0 1px 3px rgba(0,0,0,0.04)',overflow:'hidden'}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 20px',borderBottom:'1px solid #F1F5F9'}}>
                    <h5 style={{fontWeight:'600',fontSize:'14px',color:'#0F172A',margin:0}}>Invoice List</h5>
                    <div style={{width:'9em'}}>
                        <Select
                            value={itemCounts}
                            onChange={handleSelectPagination}
                            options={countList}
                            placeholder="Select item count"
                        />
                    </div>
                </div>
                <div style={{background:'#F8FAFC',padding:'16px 20px',borderBottom:'1px solid #F1F5F9'}}>
                    <div style={{display:'flex',flexWrap:'wrap',gap:'16px',alignItems:'flex-end'}}>
                        <div>
                            <label style={{fontWeight:'500',fontSize:'13px',color:'#475569',marginBottom:'6px',display:'block'}}>Start Date <span style={{color:'#94A3B8',fontSize:'11px'}}>UTC</span></label>
                            <DateRangePicker
                                onCallback={(date) => handleDate(date, "start")}
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    startDate: moment(startDate),
                                    locale: { format: 'MMMM/DD/YYYY' },
                                }}
                            >
                                <input type="text" className="form-control" style={{minWidth:'220px',borderRadius:'8px',border:'1px solid #E2E8F0',fontSize:'13px'}} />
                            </DateRangePicker>
                        </div>
                        <div>
                            <label style={{fontWeight:'500',fontSize:'13px',color:'#475569',marginBottom:'6px',display:'block'}}>End Date <span style={{color:'#94A3B8',fontSize:'11px'}}>UTC</span></label>
                            <DateRangePicker
                                onCallback={(date) => handleDate(date, "end")}
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    startDate: moment(endDate),
                                    locale: { format: 'MMMM/DD/YYYY' },
                                }}
                            >
                                <input type="text" className="form-control" style={{minWidth:'220px',borderRadius:'8px',border:'1px solid #E2E8F0',fontSize:'13px'}} />
                            </DateRangePicker>
                        </div>
                        <div>
                            <label style={{fontWeight:'500',fontSize:'13px',color:'#475569',marginBottom:'6px',display:'block'}}>Account</label>
                            <div style={{minWidth:'220px'}}>
                                <Select
                                    value={accountSelect}
                                    onChange={handleAccountSelect}
                                    options={accountOption}
                                    isClearable
                                    placeholder="Select Account"
                                />
                            </div>
                        </div>
                        <div style={{display:'flex',alignItems:'center',gap:'8px',paddingBottom:'4px'}}>
                            <input type="checkbox" onChange={handleChecked} checked={isChecked} style={{width:'16px',height:'16px',accentColor:'#10B981'}} />
                            <span style={{fontSize:'13px',color:'#475569',fontWeight:'500'}}>Exclude $0.00</span>
                        </div>
                        <button type="button" onClick={getInvoiceList} style={{background:'linear-gradient(135deg, #10B981, #059669)',color:'#fff',border:'none',borderRadius:'10px',padding:'8px 20px',fontSize:'13px',fontWeight:'500',cursor:'pointer',boxShadow:'0 2px 8px rgba(16,185,129,0.25)',marginLeft:'auto'}}>
                            Generate <i className={`${isBtnSpin ? 'icon-spinner4 spinner' : 'icon-arrow-right8'} ml-2`}></i>
                        </button>
                    </div>
                </div>
                <div style={{overflowX:'auto',overflowY:'auto',maxHeight:'56em'}}>
                    <table className="table table-striped" style={{margin:0}}>
                        <thead>
                            <tr>
                                <th>Account</th>
                                <th>Create Date</th>
                                <th>Frequency</th>
                                <th>Date Range</th>
                                <th>Invoice Number</th>
                                <th style={{textAlign:'right'}}>Outbound Minutes</th>
                                <th style={{textAlign:'right'}}>Outbound Cost</th>
                                <th style={{textAlign:'right'}}>Total Cost</th>
                                <th>Download</th>
                                <th>Send Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isGetting ? <CustomLoader /> : renderTableData()}
                        </tbody>
                    </table>
                </div>
                <div style={{padding:'12px 20px',borderTop:'1px solid #F1F5F9',textAlign:'center'}}>
                    <Pagination
                        activePage={activePages}
                        itemsCountPerPage={itemCounts.value}
                        totalItemsCount={totalCount}
                        pageRangeDisplayed={5}
                        onChange={handlePageNumber}
                    />
                </div>
            </div>
        </div>
    )
}

export default withRouter(InvoiceTable)
